import React, { useState } from 'react';
import { Container, Header, ExpandButton, IconContainer } from '../../Tabs.styles';
import CustomTitle from '../../../CustomTitle/index';
import { DocList } from './CollapsibleDocuments.styles';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import DocumentItem from '../../../../DocumentItem';
import { hexToRgba } from '../../../../../utils/helpers';

const CollapsibleDocuments = ({ documents = [], icon, title, segmentColor }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const visibleDocuments = isExpanded ? documents : documents.slice(0, 2);

  return (
    <Container>
      <Header>
        <IconContainer bgColor={segmentColor}>{/* <FaChevronDown /> */}</IconContainer>
        <CustomTitle title={title} count={documents.length} />
        <ExpandButton showIcon={documents.length > 1} onClick={toggleExpand}>
          {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
        </ExpandButton>
      </Header>

      <DocList
        bgColor={hexToRgba(segmentColor, 0.5)}
        isExpanded={isExpanded}
        documnetsLength={documents?.length}
      >
        {visibleDocuments.map((src, index) => (
          <div
            key={index}
            style={{
              backgroundColor: 'white',
              paddingLeft: '5px',
              paddingTop: '5px',
              borderRadius: '6px',
              margin: '6px',
              height: '48px',
            }}
          >
            <DocumentItem doc={src} showThumbnail={true} />
          </div>
        ))}
      </DocList>
    </Container>
  );
};

export default CollapsibleDocuments;
